<template>
  <div :class="$style.box">
    <div style="height: 0.1px"></div>
    <header :class="$style.title">
      <img :src="`${$cdnUrl}/seckill/dialog/rules/guize_zhubiaoti.png`" />
    </header>
    <main :class="$style.content">
      <img :src="`${$cdnUrl}/seckill/dialog/rules/guize_daijinquan.png`" />
      <div>
        1、只有在活动页面绑定游戏账号，才可参与抢代金券活动。<br />
        2、单个游戏账号，在游戏内完成首充，即获得当天的抢券资格。<br />
        3、代金券有时间限制，请及时使用。 <br />
        4、代金券仅支持部分游戏，如有疑问请【联系客服】。<br />
        5、成功抢到手办的用户，请及时填写【收件信息】，或附带“成功抢到手办的截屏”联系【客服】，便于奖励发放。<br />
        6、成功抢到手办的用户，活动结束后5个工作日内未填写收件信息或联
        系客服，则视为自动放弃奖励。<br />
        7、活动最终解释权归官方所有。
      </div>
      <img :src="`${$cdnUrl}/seckill/dialog/rules/guize_libao.png`" />
      <div>
        1、在活动页面绑定游戏账号后，才可领取游戏礼包。<br />
        2、每个绑定的游戏账号仅可领取1次。<br />
        3、领取到的礼包请及时兑换，避免逾期无法使用。<br />
        4、活动最终解释权归官方所有。
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
}
</script>

<style lang='scss' module>
.box {
  width: 100vw;
  height: 100vh;
  padding: 16px 24px 24px 17px;
  background-color: #2c0d0e;
  .title {
    width: 100%;
    text-align: center;
    > img {
      width: 69px;
      height: 16px;
    }
  }
  .content {
    > img {
      width: auto;
      height: 13px;
      margin-top: 30px;
    }
    > div {
      white-space: pre-line;
      font-size: 10px;
      font-weight: 400;
      color: #9b7867;
      line-height: 13px;
    }
  }
}
</style>